import React from 'react';

interface ChartCardProps {
	title: string;
	subtitle?: string;
	children: React.ReactNode;
	actions?: React.ReactNode;
	loading?: boolean;
	className?: string;
}

const ChartCard = (props: ChartCardProps) => {
	const { title, subtitle, children, actions, loading = false, className = '' } = props;

	return (
		<div className={ `chart-card ${ className }` }>
			<div className="chart-card-header">
				<div className="chart-card-titles">
					<p className="chart-card-title">{ title }</p>
					{ subtitle && <p className="chart-card-subtitle">{ subtitle }</p> }
				</div>
				{ actions && (
					<div className="chart-card-actions">{ actions }</div>
				) }
			</div>
			<div className="chart-card-body">
				{
					loading && (
						<div className="chart-card-loading">
							<span className="chart-card-spinner" aria-label="Cargando" />
						</div>
					)
				}
				<div className={ `chart-card-content ${ loading ? 'is-loading' : '' }` }>
					{ children }
				</div>
			</div>
		</div>
	)
}

export default ChartCard;
